// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202601291104/js/" + chunkId + "." + {"44":"e9c09ecb","225":"a6d1aa43","481":"664634a5","486":"2052c8c1","770":"269dfbbc"}[chunkId] + ".0.6728137989727361.chunk.js";
};